import { type JSX, useState } from 'react';
import {
  Alert,
  Button,
  Center,
  Paper,
  PasswordInput,
  Stack,
  Text,
  TextInput,
  Title,
} from '@mantine/core';
import { type Sessao, ErroApi, api } from '../lib/api.js';

export function Login({ aoEntrar }: { aoEntrar: (s: Sessao) => void }): JSX.Element {
  const [email, setEmail] = useState('');
  const [senha, setSenha] = useState('');
  const [erro, setErro] = useState<string | null>(null);
  const [entrando, setEntrando] = useState(false);

  async function enviar(evento: React.FormEvent): Promise<void> {
    evento.preventDefault();
    setEntrando(true);
    setErro(null);
    try {
      aoEntrar(await api.post<Sessao>('/admin/login', { email, senha }));
    } catch (e) {
      // A mensagem vem do servidor e é deliberadamente única: distinguir
      // "e-mail não existe" de "senha errada" tornaria o painel um oráculo de
      // quais e-mails têm acesso.
      setErro(
        e instanceof ErroApi
          ? e.status === 429
            ? 'Muitas tentativas. Aguarde alguns minutos.'
            : e.message
          : 'falha ao entrar',
      );
    } finally {
      setEntrando(false);
    }
  }

  return (
    <Center mih="100vh" p="md">
      <Paper withBorder shadow="sm" p="xl" w={380} component="form" onSubmit={enviar}>
        <Stack gap="md">
          {/*
            Aqui a marca tem espaço: centralizada e maior que no cabeçalho.
            `alt=""` pelo mesmo motivo de lá — o nome do aeroclube está escrito
            logo abaixo, e repetir no leitor de tela só atrapalha.
          */}
          <div style={{ textAlign: 'center' }}>
            <img
              src="/marca/logo-acpp.png"
              alt=""
              width={160}
              height={64}
              style={{ display: 'inline-block' }}
            />
          </div>
          <div>
            <Title order={1} size="h3">
              Curadoria
            </Title>
            <Text size="sm" c="dimmed">
              Aeroclube de Presidente Prudente
            </Text>
          </div>

          <TextInput
            label="E-mail"
            type="email"
            value={email}
            autoComplete="username"
            required
            data-autofocus
            onChange={(e) => setEmail(e.currentTarget.value)}
          />
          <PasswordInput
            label="Senha"
            value={senha}
            autoComplete="current-password"
            required
            onChange={(e) => setSenha(e.currentTarget.value)}
          />

          {erro && (
            <Alert color="red" variant="light" role="alert">
              {erro}
            </Alert>
          )}

          <Button type="submit" variant="filled" loading={entrando} fullWidth>
            {entrando ? 'Entrando…' : 'Entrar'}
          </Button>
        </Stack>
      </Paper>
    </Center>
  );
}
